import React from 'react'
import {oneWayAnimation} from '@startlibs/utils'

export const defaultListAnimation = oneWayAnimation('opacity:1;','opacity:0;')
